import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

export const useSchemaSendEmail = () => {
  const { t } = useTranslation();

  const sendEmailSchema = yup.object().shape({
    subject: yup
      .string()
      .required(t('event:validationMessage.fieldRquired'))
      .max(75, t('event:validationMessage.maxLength', { max: 75 })),
    body: yup.string().required(t('event:validationMessage.fieldRquired')),
    participant: yup.array().of(yup.number()),
  });

  return sendEmailSchema;
};
